import SBEditable from "../../../components/sbEditable/sbEditable";
import styles from "./seasonalSeriesPanel.module.scss";
import {RenderStoryblokComponent} from "../../../helpers/bloksRenderer";
import StoryblokImageBasic from "../../../components/storyblokImageBasic/storyblokImageBasic";

function SeasonalSeriesPanel({blok, story_language}) {
  const banner = blok.banner_image;
  const isNewSeasonPicks = blok.isNewSeasonPicks;

  return (
    <SBEditable blok={blok}>
      <div className={styles.root}>
        <div className={styles.imageContainer}>
          {banner && banner.filename ? (
            <StoryblokImageBasic
              image={banner}
              width={380}
              height={68}
              sizes={{
                "-576": "380x68",
                "-1152": "760x136",
                "1152-": "760x136",
              }}
            />
          ) : null}
        </div>
        <div className={styles.headerContainer}>
          <h1>{blok.title}</h1>
        </div>
        <div
          className={
            !isNewSeasonPicks
              ? `${styles.cardContainer}`
              : `${styles.seasonPicksContainer}`
          }
        >
          {blok.card_container &&
            blok.card_container.map((itemBlok, index) => {
              return RenderStoryblokComponent(
                itemBlok,
                null,
                story_language,
                {
                  isNewSeasonPicks,
                  ...blok,
                },
                index
              );
            })}
        </div>
      </div>
    </SBEditable>
  );
}

export default SeasonalSeriesPanel;
